<div *ngIf="isOpen" [ngClass]="type" class="toast-outlet" id="toast-outlet" role="status">
    <img
        *ngIf="icon"
        [src]="'/assets/icons/' + icon + '.svg'"
        alt="alert"
        class="toast-outlet__icon"
    />
    <div class="toast-outlet__content">
        <p *ngIf="title" id="toast-outlet_title" class="toast-outlet__title">
            {{ title }}
        </p>
        <p *ngIf="message" id="toast-outlet_message" [innerHTML]="message"></p>
    </div>
    <button type="button" class="toast-outlet__close" (click)="handleClose()" aria-label="Close">
        <img src="/assets/icons/remove-icon-blue.svg" alt="close" />
    </button>
</div>
